<template>
  <g>
    <path
      d="M7 17.0002C8.65685 17.0002 10 15.6571 10 14.0002C10 12.3434 8.65685 11.0002 7 11.0002C5.34315 11.0002 4 12.3434 4 14.0002C4 15.6571 5.34315 17.0002 7 17.0002Z"
    />
    <path
      d="M11 9.00024C12.6569 9.00024 14 7.6571 14 6.00024C14 4.34339 12.6569 3.00024 11 3.00024C9.34315 3.00024 8 4.34339 8 6.00024C8 7.6571 9.34315 9.00024 11 9.00024Z"
    />
    <path
      d="M16.6 20.6003C18.2569 20.6003 19.6 19.2572 19.6 17.6003C19.6 15.9435 18.2569 14.6003 16.6 14.6003C14.9432 14.6003 13.6 15.9435 13.6 17.6003C13.6 19.2572 14.9432 20.6003 16.6 20.6003Z"
    />
  </g>
</template>
